import React from 'react'
import styled from '@emotion/styled'

import { fontWeightSemibold } from '../../constants/principles'

export default ({ name, value, text, onClick }) => {
  return (
    <AnswerDiv>
      <StyledInput type={'radio'} id={value} name={name} value={value} onClick={onClick} />
      <StyledLabel htmlFor={value}>{text}</StyledLabel>
    </AnswerDiv>
  )
}
const AnswerDiv = styled.div`
  padding-bottom: 8px;
  font-weight: normal;
  display: flex;
  align-items: flex-start;
`
//used for autotrader which has styling applied to labels
const StyledLabel = styled.label`
  padding-left: 8px;
  margin-bottom: 0;
  font-weight: ${fontWeightSemibold};
`
//used for autotrader which has styling applied to inputs
const StyledInput = styled.input`
  margin-bottom: 0;
  flex-shrink: 0;
`
